/**
 * class used to set default headers and also provide method to set additional
 * headers while sending any http request
 */
class ApiHeader {
  private headers: { [key: string]: string };

  headersObject: Headers;

  constructor(readonly headerConfig: { [key: string]: string } = {}) {
    /**
     * setting default headers
     */
    this.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      ...headerConfig
    };
    this.headersObject = new window.Headers(this.headers);
  }

  /**
   * setting additional headers
   * @param   {Object} headersObject additional headers as key value pair
   */
  setAdditionalHeaders(
    headersObject: { [key: string]: string } = {},
    authData: any = {}
  ) {
    if (headersObject && Object.keys(headersObject).length > 0) {
      Object.keys(headersObject).forEach((headerKey) => {
        let headerVal = headersObject[headerKey];
        if (headerVal) {
          /**
           * checking the authorization header for API requests
           */
          if (headerVal.indexOf('$accessToken') >= 0) {
            headerVal = headersObject[headerKey].replaceAll(
              '$accessToken',
              authData.accessToken
            );
          }
          if (headerVal.indexOf('$idToken') >= 0) {
            headerVal = headersObject[headerKey].replaceAll(
              '$idToken',
              authData.idToken
            );
          }
          this.headersObject.set(headerKey, headerVal);
        }
      });
    }
  }
}
export { ApiHeader };
